export const OBJECT_CREATED = 'object_created' as const;
export const FIELD_CHANGED = 'field_changed' as const;
export const UNAVAILABLE_FEATURE_TOOLTIP = 'This feature is not yet available for this data type';

export type TriggerKind = typeof OBJECT_CREATED | typeof FIELD_CHANGED;
